import React from "react";
import MyYouthList from "./my-youth-list";

export const MyYouthRoutes = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: "my-youth",
      element: <MyYouthList />,
    },
  ],
};
